import { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import classes from "../maintainers.module.scss";

const ProductsSelectCategory = ({ showConfirm, setShowConfirm, confirmChange }) => {
	const { categories } = useSelector((state) => state.maintainers_products);

	const [selectOption, setSelectOption] = useState("");

	const handleClose = () => {
		setShowConfirm(false);
	};

	const handleCancel = () => {
		setSelectOption("");
		setShowConfirm(false);
	};

	const handleConfirm = () => {
		setShowConfirm(false);
		confirmChange(selectOption);
	};

	return (
		<Modal show={showConfirm} onHide={handleClose} backdrop="static" keyboard={false}>
			<div>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: "1em" }}> Selecciona la nueva categoría</Modal.Title>
				</Modal.Header>
				<Modal.Body style={{ padding: "15px 11px" }}>
					{categories &&
						categories.map((category) => (
							<div key={category.value}>
								<div
									className={`${classes.option_category} ${
										selectOption && String(selectOption) === String(category.value) && classes.active
									}`}
									onClick={() => setSelectOption(category.value)}
								>
									{category.label}
								</div>
							</div>
						))}
				</Modal.Body>
				<Modal.Footer>
					<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleCancel()}>
						CANCELAR
					</Button>

					<Button style={{ fontSize: "0.8em" }} variant="success" onClick={() => handleConfirm()}>
						CONFIRMAR
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default ProductsSelectCategory;
